import CashPickupInformation from '@components/transferTracking/transferDetails/CashPickupInformation';
import CustomStepper from '@components/transferTracking/transferDetails/CustomStepper';
import RecipientDetails from '@components/transferTracking/transferDetails/RecipientDetails';
import TransactionDetails from '@components/transferTracking/transferDetails/TransactionDetails';
import { Grid } from '@mui/material';
import LatestStatusBar from './transferDetails/StatusRefreshedBar';
import TransferStatusBanner from './TransferStatusBanner';
import TransferTrackingDetailsCont from './TransferTrackingCont';

const TransferProgress = () => {
	return (
		<>
			<Grid container>
				<Grid item xs={12}>
					<TransferStatusBanner />
				</Grid>
				<Grid item xs={12}>
					<CustomStepper />
				</Grid>
			</Grid>
		</>
	);
};

const TransferDetails = () => {
	return (
		<>
			<Grid container direction="column">
				<Grid item>
					<TransactionDetails />
				</Grid>
				<Grid item>
					<CashPickupInformation />
				</Grid>
				<Grid item>
					<RecipientDetails />
				</Grid>
			</Grid>
		</>
	);
};

const TransferSummary = () => {
	return (
		<>
			<Grid container spacing={{ sm: 4 }}>
				<Grid item xs={12} sm={6} py={{ xs: '24px' }}>
					<TransferProgress />
				</Grid>
				<Grid item xs={12} sm={6} py={{ xs: '24px' }}>
					<TransferDetails />
				</Grid>
			</Grid>
		</>
	);
};

const TransferTrackingDetails = () => {
	return (
		<>
			<TransferTrackingDetailsCont>
				<Grid container direction="column">
					<Grid item py={{ xs: '24px' }}>
						<LatestStatusBar />
					</Grid>
					<Grid item>
						<TransferSummary />
					</Grid>
				</Grid>
			</TransferTrackingDetailsCont>
		</>
	);
};

export default TransferTrackingDetails;
